import { render, staticRenderFns } from "./ReserveResource.vue?vue&type=template&id=01b3fa02"
import script from "./ReserveResource.ts?vue&type=script&lang=ts&external"
export * from "./ReserveResource.ts?vue&type=script&lang=ts&external"
import style0 from "./ReserveResource.vue?vue&type=style&index=0&id=01b3fa02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports